<template>
    <div>
        <div class="mb-3">
            <h3>{{ country.name }}</h3>
            <div class="row">
                <div class="col-md-3 col-lg-2" v-for="city in displayCities" :key="city.id">
                    <a v-router-link="{ name: 'CityDetail', params: { id: city.id }}">
                        <h5>{{ city.name }} <span><i class="icons8-user-account"></i>{{ city.members.aggregate.count | formatNumber }}</span></h5>
                    </a>
                </div>
            </div>
        </div>
        <see-more-button
            class="mb-4"
            v-if="cities && cities.length > limit"
            :count="cities && cities.length - limit"
            @showMore="(status) => showMore = status"
        ></see-more-button>
    </div>
</template>

<script>
import SeeMoreButton from '@/components/global/SeeMoreButton';

export default {
    name: 'country-card',

    components: {
        SeeMoreButton
    },

    props: {
        country: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    data() {
        return {
            limit: 48,
            showMore: false,
        }
    },

    computed: {
        cities() {
            return this.country.cities.filter(city => {
                return city.members.aggregate.count > 0
            }).sort((a, b) => {
                return b.members.aggregate.count - a.members.aggregate.count
            });
        },
        
        displayCities() {
            return (this.showMore) ? this.cities: this.cities.slice(0, this.limit); 
        },
    },

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },

    methods: {
        handleResize() {
            let windowWidth = window.innerWidth;

            if (windowWidth < 768) {
                this.limit = 12;
            } else {
                this.limit = 48;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    h3 {
        color: $primary;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.4;
        margin-bottom: 15px;

        @include media-breakpoint-up(lg) {
            font-size: 20px;
            font-weight: 600;
        }
    }

    h5 {
        color: #3E4041;
        font-size: 16px;
        font-weight: 600;
        outline: none;

        span {
            font-size: 16px;
            margin-left: 5px;
            color: $grey-text;

            i {
                vertical-align: bottom;
                margin-right: 5px;
            }
        }
    }
</style>
